import React from 'react';

const HourlyChart = ({ bucketName, hourData, allHourLabels }) => {
  if (!hourData) return null;
  const labels = allHourLabels;
  if (labels.length === 0) return null;

  const points = labels.map(l => hourData[l] || 0);
  const maxVal = Math.max(...points, 1);
  const padding = { top: 20, right: 20, bottom: 40, left: 40 };
  const W = 500;
  const H = 180;
  const plotW = W - padding.left - padding.right;
  const plotH = H - padding.top - padding.bottom;

  const xStep = labels.length > 1 ? plotW / (labels.length - 1) : plotW;
  const coords = points.map((v, i) => ({
    x: padding.left + (labels.length > 1 ? i * xStep : plotW / 2),
    y: padding.top + plotH - (v / maxVal) * plotH,
  }));
  const polyline = coords.map(c => `${c.x},${c.y}`).join(' ');

  const yTicks = [];
  const step = Math.max(1, Math.ceil(maxVal / 4));
  for (let v = 0; v <= maxVal; v += step) yTicks.push(v);
  if (yTicks[yTicks.length - 1] < maxVal) yTicks.push(Math.ceil(maxVal));

  return (
    <div className="hourly-chart-panel">
      <h4 className="hourly-chart-title">{bucketName} (Total)</h4>
      <svg viewBox={`0 0 ${W} ${H}`} className="hourly-chart-svg" preserveAspectRatio="xMidYMid meet">
        {yTicks.map(v => {
          const y = padding.top + plotH - (v / maxVal) * plotH;
          return (
            <g key={v}>
              <line x1={padding.left} y1={y} x2={W - padding.right} y2={y}
                stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
              <text x={padding.left - 6} y={y + 4} textAnchor="end"
                fill="rgba(255,255,255,0.45)" fontSize="10">{v}</text>
            </g>
          );
        })}
        <polyline points={polyline} fill="none" stroke="#3b82f6" strokeWidth="2"
          strokeLinejoin="round" strokeLinecap="round" />
        {coords.map((c, i) => (
          <circle key={i} cx={c.x} cy={c.y} r="3" fill="#3b82f6" />
        ))}
        {labels.map((l, i) => {
          const x = padding.left + (labels.length > 1 ? i * xStep : plotW / 2);
          const parts = l.split('-');
          return (
            <text key={l} x={x} y={H - 4} textAnchor="middle"
              fill="rgba(255,255,255,0.5)" fontSize="9">
              {parts[0]}-{parts[1]}
            </text>
          );
        })}
      </svg>
    </div>
  );
};

export default HourlyChart;
